import {useEffect} from 'react';
import {setLoadedComponents} from '../omniture-utils';

const useOmnitureLoaded = (loadedComponent: string) => {
  useEffect(() => {
    if (!loadedComponent) {
      return;
    }

    setLoadedComponents(loadedComponent);
  }, [loadedComponent]);
};

export default useOmnitureLoaded;
